export default "__VITE_ASSET__5d950a3c__"